// services/priceLists.js — ценовите листи (т. 5 a, решение на Макс 17.10.2026).
//
// Листата („Едро", „Дистрибутори", „Ресторанти") върви с КЛИЕНТА
// (contacts.price_list_id) — човекът никога не я избира във фактурата.
// Цена на артикул: изрична цена в листата → иначе общият процент отстъпка от
// основната цена на артикула → иначе основната цена (няма листа).
// Цената пак може да се смени на ръка на реда.
//
// Чисти функции — ползват ги сървърът (проверката) и екранът (цената).

const { round2 } = require('./totals');

const MAX_PRICES = 5000;
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

// Важи ли листата към датата (ISO): изключена или извън „от–до" — не.
function activeOn(list, today) {
  if (!list || list.active === false) return false;
  const d = String(today || '').slice(0, 10);
  if (d && list.valid_from && d < list.valid_from) return false;
  if (d && list.valid_to && d > list.valid_to) return false;
  return true;
}

// Листата на клиента или null.
function listOf(lists, contact) {
  const id = contact && contact.price_list_id;
  if (id == null || id === '') return null;
  return (Array.isArray(lists) ? lists : []).find((l) => Number(l.id) === Number(id)) || null;
}

// { price, how: 'price'|'pct', pct?, list } или null (основната цена).
function priceFor(list, article, today) {
  if (!article || !activeOn(list, today)) return null;
  const hit = (Array.isArray(list.prices) ? list.prices : []).find((p) => Number(p.article_id) === Number(article.id));
  if (hit && hit.price !== '' && hit.price != null && Number.isFinite(Number(hit.price))) {
    return { price: round2(Number(hit.price)), how: 'price', list: list.name || '' };
  }
  const pct = Number(list.discount_pct);
  if (pct > 0 && pct < 100) {
    return { price: round2((Number(article.unit_price) || 0) * (1 - pct / 100)), how: 'pct', pct, list: list.name || '' };
  }
  return null;
}

// Проверка и оформяне на листа преди запис. articleIds: артикулите на
// фирмата (Set от числа) — чужд артикул в листата е грешка, не тих ред.
// Връща { data } или { error }.
function shape(b, existing, articleIds) {
  const src = Object.assign({}, existing || {}, b || {});
  const name = String(src.name == null ? '' : src.name).trim().slice(0, 120);
  if (!name) return { error: 'Въведете име на листата (напр. „Едро").' };
  let pct = src.discount_pct === '' || src.discount_pct == null ? 0 : Number(String(src.discount_pct).replace(',', '.'));
  if (!Number.isFinite(pct) || pct < 0 || pct >= 100) return { error: 'Отстъпката е процент от 0 до 99.' };
  pct = round2(pct);
  const from = String(src.valid_from || '').slice(0, 10);
  const to = String(src.valid_to || '').slice(0, 10);
  if ((from && !DATE_RE.test(from)) || (to && !DATE_RE.test(to))) return { error: 'Не разбрах датата „важи от/до".' };
  if (from && to && from > to) return { error: '„Важи от" е след „до".' };
  const raw = Array.isArray(src.prices) ? src.prices : [];
  if (raw.length > MAX_PRICES) return { error: 'Листата е с над ' + MAX_PRICES + ' цени.' };
  const seen = new Set();
  const prices = [];
  for (const p of raw) {
    const aid = Number(p && p.article_id);
    if (!Number.isInteger(aid) || aid <= 0) continue;
    if (p.price === '' || p.price == null) continue; // празно = по процента
    const price = Number(String(p.price).replace(',', '.'));
    if (!Number.isFinite(price) || price < 0) return { error: 'Цената в листата трябва да е число, не по-малко от 0.' };
    if (articleIds && !articleIds.has(aid)) return { error: 'В листата има артикул от друга фирма.' };
    if (seen.has(aid)) continue;
    seen.add(aid);
    prices.push({ article_id: aid, price: round2(price) });
  }
  return { data: {
    company_id: Number(src.company_id) || null,
    name, discount_pct: pct, valid_from: from, valid_to: to,
    active: src.active === undefined ? true : !!src.active && src.active !== 'false',
    prices,
  } };
}

module.exports = { activeOn, listOf, priceFor, shape, MAX_PRICES };
